module.exports = __webpack_public_path__ + "img/blockchain-integration.65180b80.png";